export let labelStyle = {
  fontSize: '11px',
  color: '#AAAAAA'
};

export let errorStyle = {
  display: 'inline-block',
  fontSize: '14px',
  color: '#dc3545'
};

export let formStyle = {
  height: '48px'
};